
import { IonIcon } from '@ionic/react'
import { handLeft } from 'ionicons/icons'
import React from 'react'
import Page from '../components/Page'

export default class extends React.Component {
  render() {
    return (
      <Page title="Gems recipes" padding>
        <p>Always 3 Gems of the same type and grade give 1 Gem of same type, one grade higher.</p>
        <p>E.g. 3 chipped Topaz = 1 flawed Topaz</p>
        <p>Grades are (in that order) e.g. for Topaz</p>
        <ol>
          <li>Chipped Topaz</li>
          <li>Flawed Topaz</li>
          <li>Topaz</li>
          <li>Flawless Topaz</li>
          <li>Perfect Topaz</li>
        </ol>
      </Page>
    )
  }
}